import React, { FC } from "react";

import { QuestionAnswer } from "./QuestionAnswer";

import { QuestionAnswerCategoryWithQuestionAnswerType } from "~/domains";

type PropsType = {
  questionAnswerCategory: Pick<
    QuestionAnswerCategoryWithQuestionAnswerType,
    "name" | "questionAnswers"
  >;
};

export const QuestionAnswerCategoryList: FC<PropsType> = ({
  questionAnswerCategory,
}: PropsType) => {
  const { name, questionAnswers } = questionAnswerCategory;

  return (
    <div>
      <h3 className="mt-4 text-xl font-bold text-primary-600">{name}</h3>

      <div className="space-y-6 mt-8">
        {questionAnswers.map((questionAnswer) => (
          <QuestionAnswer
            key={questionAnswer.id}
            questionAnswer={questionAnswer}
          />
        ))}
      </div>
    </div>
  );
};
